(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('temp-customer-sector', {
            parent: 'entity',
            url: '/temp-customer-sector?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.tempCustomerSector.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/temp-customer-sector/temp-customer-sectors.html',
                    controller: 'TempCustomerSectorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tempCustomerSector');
                    $translatePartialLoader.addPart('status');
                    $translatePartialLoader.addPart('workingHours');
                    /*$translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');*/
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('temp-customer-sector-detail', {
            parent: 'entity',
            url: '/temp-customer-sector/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.tempCustomerSector.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/temp-customer-sector/temp-customer-sector-detail.html',
                    controller: 'TempCustomerSectorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tempCustomerSector');
                    $translatePartialLoader.addPart('status');
                    $translatePartialLoader.addPart('workingHours');
                    /*$translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');
                    $translatePartialLoader.addPart('workingHours');*/
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TempCustomerSector', function($stateParams, TempCustomerSector) {
                    return TempCustomerSector.get({id : $stateParams.id});
                }]
            }
        })
        .state('temp-customer-sector.new', {
            parent: 'temp-customer-sector',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-customer-sector/temp-customer-sector-dialog.html',
                    controller: 'TempCustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startedAt: null,
                                endedAt: null,
                                status: null,
                                issuedDate: null,
                                issuedBy: null,
                                main: null,
                                phone: null,
                                monday: null,
                                tuesday: null,
                                wednesday: null,
                                thursday: null,
                                friday: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('temp-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('temp-customer-sector');
                });
            }]
        })
        .state('temp-customer-sector.edit', {
            parent: 'temp-customer-sector',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-customer-sector/temp-customer-sector-dialog.html',
                    controller: 'TempCustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TempCustomerSector', function(TempCustomerSector) {
                            return TempCustomerSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('temp-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('temp-customer-sector.delete', {
            parent: 'temp-customer-sector',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-customer-sector/temp-customer-sector-delete-dialog.html',
                    controller: 'TempCustomerSectorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TempCustomerSector', function(TempCustomerSector) {
                            return TempCustomerSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('temp-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
